import { useEffect, useState } from 'react';

import { startScrapeGuard } from 'utils/scrapeGuard';

/**
 * True once a list-extractor extension has been detected on the page.
 *
 * Latches: it never returns to false for the life of the mount. The extension
 * being closed again does not mean the catalogue was not already read, and a
 * value that flickers would let a tool that toggles its own panel collect the
 * rows in the gaps.
 */
const useScrapeGuard = () => {
  const [detected, setDetected] = useState(false);

  useEffect(() => startScrapeGuard(() => setDetected(true)), []);

  return detected;
};

export default useScrapeGuard;
